import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "./accountContext";

export const useRedirectToLogin = () => {
  const user = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === null) {
      navigate("/signup", {
        replace: true,
      });
    }
  }, [user]);
};

export const useQueryParameters = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};
